import { createReducer, on } from "@ngrx/store";
import { GroupState, initialGroupState } from "./group.state";
import {
  AddGroup,
  AddGroupError,
  AddGroupSuccess,
  DeleteGroups,
  DeleteGroupsError,
  DeleteGroupsSuccess,
  GetCurrentPageNumber,
  GetCurrentPageNumberError,
  GetCurrentPageNumberSuccess,
  GetGroupByOrgOptionalCentre,
  GetGroupByOrgOptionalCentreError,
  GetGroupByOrgOptionalCentreSuccess,
  GetGroupByOrgOptionalCentreTutorFlow,
  GetGroupByOrgOptionalCentreTutorFlowError,
  GetGroupByOrgOptionalCentreTutorFlowSuccess,
  GetGroupTable,
  GetGroupTableError,
  GetGroupTableLength,
  GetGroupTableLengthError,
  GetGroupTableLengthSuccess,
  GetGroupTableSuccess,
  GetOrgCentreGroupList,
  GetOrgCentreGroupListError,
  GetOrgCentreGroupListSuccess,
  ProcessGetLearnerIdsToAssign,
  ProcessGetLearnerIdsToAssignError,
  ProcessGetLearnerIdsToAssignSuccess,
  ResetGroupState,
  ResetOrgCentreGroupList,
  UpdateGroupTable,
  UpdateGroupTableError,
} from "./group.actions";

export const GroupReducers = createReducer(
  initialGroupState,
  on(AddGroup, (state): GroupState => {
    return {
      ...state,
      crudGroupLoader: true,
      crudResult: null,
      crudError: null,
    };
  }),
  on(AddGroupSuccess, (state, action): GroupState => {
    return {
      ...state,
      crudGroupLoader: false,
      crudResult: action.result,
      crudError: null,
    };
  }),
  on(AddGroupError, (state, action): GroupState => {
    return {
      ...state,
      crudGroupLoader: false,
      crudResult: null,
      crudError: action.crudError,
    };
  }),
  on(ResetGroupState, (): GroupState => {
    return initialGroupState;
  }),
  on(GetGroupTable, (state): GroupState => {
    return {
      ...state,
      listLoader: true,
      listError: null,
    };
  }),
  on(GetGroupTableSuccess, (state, action): GroupState => {
    return {
      ...state,
      list: action.result,
      listLoader: false,
      initialList: false,
    };
  }),
  on(GetGroupTableError, (state, action): GroupState => {
    return {
      ...state,
      listError: action.error,
    };
  }),
  on(GetGroupTableLength, (state): GroupState => {
    return {
      ...state,
    };
  }),
  on(GetGroupTableLengthSuccess, (state, action): GroupState => {
    return {
      ...state,
      listLength: action.result,
    };
  }),
  on(GetGroupTableLengthError, (state, action): GroupState => {
    return {
      ...state,
      listError: action.error,
    };
  }),
  on(UpdateGroupTable, (state, action): GroupState => {
    return {
      ...state,
      listRequestDto: action.request,
      listUpdateStatus: null,
      initialList: false
    };
  }),
  on(UpdateGroupTableError, (state, action): GroupState => {
    return {
      ...state,
      listUpdateStatus: action.error,
    };
  }),
  on(GetOrgCentreGroupList, (state): GroupState => {
    return {
      ...state,
      orgCentreGroupLoader: true,
      orgCentreGroupError: null,
    }
  }),
  on(GetOrgCentreGroupListSuccess, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupLoader: false,
      orgCentreGroupError: null,
      orgCentreGroupList: action.result
    }
  }),
  on(GetOrgCentreGroupListError, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupLoader: false,
      orgCentreGroupError: action.error
    }
  }),
  on(ResetOrgCentreGroupList, (state): GroupState => {
    return {
      ...state,
      orgCentreGroupList: [],
    }
  }),
  on(DeleteGroups, (state): GroupState => {
    return {
      ...state,
      deleteGroupLoader: true,
      listLoader: true,
      isDeleteGroup: false,
      deleteGroupError: null
    }
  }),
  on(DeleteGroupsSuccess, (state, action): GroupState => {
    return {
      ...state,
      deleteGroupLoader: false,
      listLoader: false,
      isDeleteGroup: action.isDeletedSuccessFully
    }
  }),
  on(DeleteGroupsError, (state, action): GroupState => {
    return {
      ...state,
      deleteGroupLoader: false,
      listLoader: false,
      isDeleteGroup: false,
      deleteGroupError: action.error
    }
  }),
  on(GetCurrentPageNumber, (state): GroupState => {
    return {
      ...state,
      deleteGroupError: null,
      currentPageNumber: 0
    };
  }),
  on(GetCurrentPageNumberSuccess, (state, action): GroupState => {
    return {
      ...state,
      currentPageNumber: action.currentPageNumber
    }
  }),
  on(GetCurrentPageNumberError, (state, action): GroupState => {
    return {
      ...state,
      deleteGroupError: action.error,
    }
  }),
  on(ProcessGetLearnerIdsToAssign, (state): GroupState => {
    return {
      ...state,
      listLoader: true,
      listError: null,
      learnerIdsToAssignCourse: null
    };
  }),
  on(ProcessGetLearnerIdsToAssignSuccess, (state, action): GroupState => {
    return {
      ...state,
      listLoader: false,
      learnerIdsToAssignCourse: action.learnerIds
    };
  }),
  on(ProcessGetLearnerIdsToAssignError, (state, action): GroupState => {
    return {
      ...state,
      listError: action.error,
      listLoader: false
    };
  }),
  on(GetGroupByOrgOptionalCentre, (state): GroupState => {
    return {
      ...state,
      orgCentreGroupList: null,
      orgCentreGroupLoader: true,
      orgCentreGroupError: null,
    }
  }),
  on(GetGroupByOrgOptionalCentreSuccess, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupList: action.result,
      orgCentreGroupLoader: false,
    }
  }),
  on(GetGroupByOrgOptionalCentreError, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupLoader: false,
      orgCentreGroupError: action.error
    }
  }),
  on(GetGroupByOrgOptionalCentreTutorFlow, (state): GroupState => {
    return {
      ...state,
      orgCentreGroupList: null,
      orgCentreGroupLoader: true,
      orgCentreGroupError: null,
    }
  }),
  on(GetGroupByOrgOptionalCentreTutorFlowSuccess, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupList: action.result,
      orgCentreGroupLoader: false,
    }
  }),
  on(GetGroupByOrgOptionalCentreTutorFlowError, (state, action): GroupState => {
    return {
      ...state,
      orgCentreGroupLoader: false,
      orgCentreGroupError: action.error
    }
  }),
);
